import OkC from "shared/util/OkcApi";
import { getPhotoError } from "./util";

/*
 * Upload a photo to the server
 *
 * @param {file} file - The photo file that comes from a file input
 * @param {string} userid - The user's id
 * @param {function} [successCb] - A function to run on success
 * @param {function} [failureCb] - A function to run on failure
 */
export default function uploadPhotoFile(file, userid, albumid, successCb, failureCb) {
	if (!file) {
		return;
	}

	const data = new FormData();
	data.append("file", file);
	data.append("userid", userid);
	data.append("albumid", albumid);
	data.append("okc_api", 1);

	OkC.legacy("/ajaxuploader", {
		type: "POST",
		data,

		success(res) {
			if (res.error) {
				if (typeof (failureCb) === "function") {
					failureCb(getPhotoError(res.error));
				}

				return;
			}

			if (typeof (successCb) === "function") {
				successCb({
					picid: res.id,
					width: res.width,
					height: res.height,
					src: res.url,
					thumb: res.large_thumb_url,
				});
			}
		},

		error(err) {
			if (typeof (failureCb) === "function") {
				failureCb(err);
			}
		},
	});
}



// WEBPACK FOOTER //
// ./src/shared/util/PhotoUpload/uploadPhotoFile.js